export default "__VITE_ASSET__CJ1pw0F7__"